import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";

import useLayout from "~/hooks/useLayout";

export default function MenuItem({ menuKey, label, path }) {
  const {
    layout: { activeMenuKeys },
  } = useLayout();

  const [active, setActive] = useState(activeMenuKeys.includes(menuKey));
  const ref = useRef();

  useEffect(() => {
    setActive(activeMenuKeys.includes(menuKey));
  }, [activeMenuKeys, menuKey]);

  let classNames = "";
  if (active) {
    classNames = "after:scale-100";
  } else {
    classNames = "after:scale-0";
  }

  return (
    <>
      <div
        ref={ref}
        className={`pr-0 flex justify-center transition-all ease-in-out`}
      >
        <React.Fragment>
          <Link
            to={`/${path}`}
            className={`flex flex-col items-center self-stretch w-full group cursor-pointer after:bg-primary after:transition-all after:duration-350 after:h-[3px] after:w-full after:relative after:bottom-0 after:rounded-b-md after:left-0 after:content-[''] transition-all duration-150 ${classNames}`}
          >
            <span className="text-gray-700 pr-0 transition-all ease-in-out uppercase font-semibold">
              {label}
            </span>
          </Link>
        </React.Fragment>
      </div>
    </>
  );
}
